/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/is_null.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * Returns `true` if the value is `NULL`, `false` otherwise.
 *
 * Note: If a field is only in some documents it will be `NULL` in the documents that did not contain it.
 *
 * @example
 * FROM employees
 * | WHERE birth_date IS NULL
 */
const definition: OperatorDefinition = {
  operator: 'IS NULL',
  name: 'is_null',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'aggregate_metric_double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'boolean',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'counter_double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'counter_integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'counter_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'date_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'exponential_histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'flattened',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geohash',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geohex',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geotile',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'ip',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'tdigest',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'version',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
